var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DataGetter',{staticClass:"m-block m-block--charts",attrs:{"url":_vm.apiRoute,"params":{
    countryISO: _vm.countryISO,
    allYears: true,
    startYear: _vm.startYear,
    indicator: _vm.indicator,
    ..._vm.extraParams,
  },"lazy":""},on:{"fetched":_vm.setMax},scopedSlots:_vm._u([{key:"default",fn:function({ data }){return [_c('ChartLayout',{attrs:{"title":_vm.title,"units":_vm.units && _vm.hideUnits ? _vm.units : null,"palette":"tints"},scopedSlots:_vm._u([(_vm.note)?{key:"notes",fn:function(){return [_vm._v(" "+_vm._s(_vm.note)+" ")]},proxy:true}:null],null,true)},[(_vm.max)?_c('DataSlicer',{staticClass:"sparkline-container",class:{ 'sparkline-container--long-lines': _vm.longLines },attrs:{"data":data,"x-axis-dimension":_vm.xAxisDimension,"y-axis-dimension":_vm.groupDimension,"value-dimension":"value","no-single-value":""},scopedSlots:_vm._u([{key:"default",fn:function({ slicedData }){return [_vm._l(([...slicedData].sort((a, b) =>
          a.name < b.name ? -1 : 1
        )),function(series,colorIndex){return [(
            !_vm.exclude.includes(series.name) &&
            !series.data.every((point) => point[1] === null)
          )?_c('Sparkline',{key:series.name,attrs:{"title":_vm.mapNames[series.name] || series.name,"units":_vm.units,"show-x-axis":"","marker-style":_vm.categories ? 'all' : 'first-last',"hide-units":_vm.hideUnits,"options":{
            chart: {
              type: _vm.chartType,
              marginLeft: 6,
              marginBottom: 24,
              height: 100,
            },
            plotOptions: {
              series: {
                pointStart: _vm.categories ? undefined : _vm.startYear,
              },
              area: _vm.provisionalYear ? {
                zoneAxis: 'x',
                zones: [
                  {
                    value: _vm.provisionalYear - 1,
                    className: ''
                  },
                  {
                    className: 'highcharts-translucent'
                  }
                ]
              } : {}
            },
            yAxis: {
              min: 0,
              max: _vm.max,
              tickAmount: 3,
              plotLines: [
                { value: 0, className: 'highcharts-zero-axis', zIndex: 3 },
                /*{ value: max, className: 'highcharts-dotted' },*/
              ],
            },
            xAxis: {
              type: _vm.categories ? 'category' : undefined,
              min: _vm.categories ? undefined : _vm.startYear,
              categories: _vm.categories,
              plotLines: _vm.provisionalYear ? [
                { value: _vm.provisionalYear - 1, className: 'highcharts-dotted', zIndex: 2 }
              ] : []
            },
            tooltip: {
              valueDecimals: _vm.decimals,
              formatter: undefined,
              headerFormat: `<span class='highcharts-header'>${
                _vm.categories ? '{series.name}' : '{point.x}'
              }</span><br>`,
              pointFormatter: function () {
                return `${
                  _vm.categories ? _vm.categories[this.x] : series.name
                }: <b>${parseFloat(this.y.toFixed(_vm.decimals))
                  .toLocaleString('fr')
                  .replace(',', '&nbsp;')}${_vm.units.replace(
                  / /g,
                  '&nbsp;'
                )}</b>`;
              },
            },
          },"series":[
            {
              ...series,
              colorIndex:
                (_vm.seriesOrder
                  ? _vm.seriesOrder.indexOf(series.name)
                  : colorIndex) % 20,
              data: series.data
                .filter((point) => _vm.categories || point[0] >= _vm.startYear)
                .sort((a, b) => {
                  if (!_vm.categories) return 0;
                  if (_vm.categories.indexOf(a[0]) > -1)
                    return (
                      _vm.categories.indexOf(a[0]) - _vm.categories.indexOf(b[0])
                    );
                  if (
                    _vm.extraParams[_vm.xAxisDimension] &&
                    _vm.extraParams[_vm.xAxisDimension].indexOf(a[0]) > -1
                  ) {
                    return (
                      _vm.extraParams[_vm.xAxisDimension].indexOf(a[0]) -
                      _vm.extraParams[_vm.xAxisDimension].indexOf(b[0])
                    );
                  }
                  return a[0] < b[0] ? -1 : 1;
                })
                .map((point) => point[1]),
            },
          ]}}):_vm._e()]})]}}],null,true)}):_vm._e()],1)]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }